import React, { FC, useCallback } from 'react';
import styled from 'styled-components';
import { Dialog, Button, Typography } from '@beeline.com/bp-design-system';
import { useTypedMutation } from 'src/utils/hooks/useTypedMutation';
import { useCustomFieldsAndObjectsIntl } from '../../translations/useCustomFieldsAndObjectsIntl';
import { DeleteCustomFieldDefinitionDocument } from '../utils/__generated__/DeleteCustomFieldDefinition.graphql';
import { CustomFieldDefinition } from '../utils/CustomFields.types';
interface Props {
  open: boolean;
  refetch: () => void;
  onClose: () => void;
  customDefinition: CustomFieldDefinition | undefined;
}
export const DeleteCustomFieldDialog: FC<React.PropsWithChildren<Props>> = ({
  refetch,
  onClose,
  open,
  customDefinition
}) => {
  const intl = useCustomFieldsAndObjectsIntl();
  const { set: deleteCustomFieldDefinition } = useTypedMutation(DeleteCustomFieldDefinitionDocument);
  const onDeleteHandler = useCallback(async () => {
    if (!customDefinition?.uid) return;
    const response = await deleteCustomFieldDefinition({ variables: { id: customDefinition.uid } });
    if (!response.errors) {
      refetch();
      onClose();
    }
  }, [customDefinition?.uid, deleteCustomFieldDefinition, onClose, refetch]);
  return (
    <Dialog
      title={intl.deleteDialogTitle}
      open={open}
      onClose={onClose}
      show={{ cancelButton: true }}
      disableBackdropClick
      actions={[
        <Button
          dataTest="confirm_button"
          variant="contained"
          color="primary"
          error
          onClick={onDeleteHandler}
          key="confirm_button"
        >
          {intl.delete}
        </Button>
      ]}
    >
      <StyledBody variant="body1" dataTest="confirm_delete">
        {intl.deleteDialogBody}
      </StyledBody>
    </Dialog>
  );
};
const StyledBody = styled(Typography)`
  && {
    margin-top: 1rem;
  }
`;
